'use client';
import React, { useState } from 'react';

const faqs = [
  {
    id: 'faq-lang',
    q: 'L\'IA répond en français ou en anglais ?',
    a: 'L\'IA s\'adapte à votre niveau. Elle peut vous corriger en français si besoin, mais la pratique se fait en anglais — c\'est l\'immersion !',
  },
  {
    id: 'faq-cancel',
    q: 'Puis-je annuler mon abonnement ?',
    a: 'Oui, à tout moment. Pas d\'engagement, pas de frais d\'annulation. Vous gardez l\'accès jusqu\'à la fin de votre période en cours.',
  },
  {
    id: 'faq-diff',
    q: 'Quelle est la différence avec ChatGPT ?',
    a: 'L\'IA Anglaispourvous est optimisée pour l\'apprentissage de l\'anglais par immersion. Elle suit la méthode de Marc, mémorise vos erreurs, et s\'adapte à votre progression — pas juste une conversation générique.',
  },
  {
    id: 'faq-marc',
    q: 'Les sessions IA remplacent-elles les séances avec Marc ?',
    a: 'Non — elles les complètent. L\'IA est là pour la pratique quotidienne. Marc reste irremplaçable pour la correction nuancée, la conversation naturelle et la progression personnalisée.',
  },
  {
    id: 'faq-level',
    q: 'Je suis débutant, est-ce adapté ?',
    a: 'Absolument. L\'IA s\'adapte à votre niveau dès la première conversation. Vous pouvez commencer avec des phrases simples et progresser à votre rythme.',
  },
];

export default function AIFaq() {
  const [open, setOpen] = useState<string | null>('faq-lang');

  return (
    <section className="py-16 lg:py-20 bg-muted/30">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <p className="section-label mb-3">FAQ</p>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-primary">Questions fréquentes</h2>
          </div>

          <div className="space-y-3">
            {faqs?.map((faq) => (
              <div
                key={faq?.id}
                className="bg-white border border-border rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpen(open === faq?.id ? null : faq?.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-muted/30 transition-colors"
                >
                  <span className="text-sm font-semibold text-primary pr-4">{faq?.q}</span>
                  <svg
                    className={`w-4 h-4 text-accent flex-shrink-0 transition-transform duration-200 ${open === faq?.id ? 'rotate-180' : ''}`}
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-250 ${open === faq?.id ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <p className="px-5 pb-4 text-sm text-secondary leading-relaxed">{faq?.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}